"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonNouns_de_de = void 0;
function commonNouns_de_de() {
    return {
        "nouns.images": "Bilder",
        "nouns.name": "Name",
        "nouns.description": "Beschreibung",
        "nouns.creationdate": "Erstellungsdatum",
        "nouns.qrcode": "QR Code",
        "nouns.actions": "Aktionen",
        "nouns.preview": "Vorschau",
        "nouns.details": "Details",
        "nouns.value": "Wert",
        "nouns.error": "Fehler",
        "nouns.icon": "Icon",
        "nouns.help": "Hilfe",
        "nouns.company": "Firma",
        "nouns.companyphone": "Firmentelefon"
    };
}
exports.commonNouns_de_de = commonNouns_de_de;
